import { APP_PERMISSIONS } from '@exam-center/permission';
import { Button, Flex } from '@shared/components';
import { WithPermission } from '@shared/permissions';

interface ProctorRequestDraftButtonsProps {
  onSaveDraft: () => void;
  onSaveDraftAndSubmit: () => void;
  disabled: boolean;
}

export default function ProctorRequestDraftButtons(
  props: Readonly<ProctorRequestDraftButtonsProps>,
) {
  const { onSaveDraft, onSaveDraftAndSubmit, disabled } = props;

  return (
    <WithPermission requiredPermission={APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.UPDATE}>
      <Flex sx={(theme) => ({ gap: theme.spacing(2.5), ml: 'auto' })}>
        <Button
          size='large'
          variant='outlined'
          color='secondary'
          onClick={onSaveDraft}
          disabled={disabled}
        >
          บันทึกแบบร่าง
        </Button>
        <Button size='large' color='primary' onClick={onSaveDraftAndSubmit} disabled={disabled}>
          ส่งคำขออนุมัติ
        </Button>
      </Flex>
    </WithPermission>
  );
}
